export const ipv6 = {
  wip: "wip",
  pdaddr: "pdaddr",
  sdaddr: "sdaddr",
  ipv6_interface_id: "ipv6_interface_id",
  ipv6_6rd_pre: "ipv6_6rd_pre",
  ipv6_pre_len: "ipv6_pre_len",
  relay_addr: "relay_addr",
  ipv6_mask_len: "ipv6_mask_len",
  ipv6wanaddr: "ipv6wanaddr",
  ipv6gateway: "ipv6gateway",
  ipv6_lan: "ipv6_lan",
  ipv6_lan_prefix: "ipv6_lan_prefix",
  pppoe_servername: "pppoe_servername",
};

export default ipv6;
